<template>
  <div class="tab-box flex flex-around flex-column bg-2">
    <div class="poster-container">
      <div class="poster-content" ref="posterContentEl"></div>
      <div class="poster-type">
        <img :src="posterType.url" class="full-img">
      </div>
      <div class="poster-touch" ref="posterTouchEl"></div>
    </div>
    <div class="poster-swiper flex flex-around">
      <span
        class="poster-swiper-item"
        :class="[`poster-swiper-item-${item.id}`, { 'active': item.id == posterType.id }]"
        v-for="item in posterTypeArr"
        :key="item.id"
        @click="setPosterType(item)"
      ></span>
    </div>
    <div class="btn-box flex flex-around">
      <div class="up-btn-box">
        <button class="btn btn-3" @click="wxUpImg">选择照片</button>
        <input type="file" name="img" id="file" accept="image/*" @change="fileHanle" v-if="wxObj == null">
      </div>
      <button class="btn btn-3" v-if="mySprite != null" @click="printFn">合成海报</button>
    </div>
  </div>
</template>

<script>
import lrz from 'lrz'
import Sprite from '../../utils/sprites'

export default {
  name: 'Poster',
  data () {
    return {
      posterType: { id: 1, url: require('../../assets/images/32.png') },
      posterTypeArr: [
        { id: 1, url: require('../../assets/images/32.png') },
        { id: 2, url: require('../../assets/images/33.png') },
        { id: 3, url: require('../../assets/images/34.png') }
      ],
      mySprite: null,
      upBase: '',
      wxObj: this.$myWx.wechatObj
    }
  },
  inject: ['slideHandle'],
  methods: {
    wxUpImg () {
      if (this.wxObj == null) return
      let wx = this.wxObj.wx
      wx.chooseImage({
        count: 1,
        sizeType: ['original', 'compressed'],
        success: r1 => {
          wx.getLocalImgData({
            localId: r1.localIds[0],
            success: r2 => {
              this.$alert.load('上传中')
              let localData = r2.localData
              if (localData.indexOf('data:image') !== 0) {
                localData = 'data:image/jpeg;base64,' + localData
              }
              localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
              this.setPoster(localData)
            }
          })
        }
      })
    },
    setPosterType (item) {
      this.posterType = item
    },
    setPoster (data) {
      let img = new Image()
      img.src = data
      this.upBase = data
      this.saveMissImgFn(this.upBase)
      img.onload = e => {
        this.mySprite = new Sprite({
          el: e.target,
          stage: this.$refs.posterContentEl,
          proxyEl: this.$refs.posterTouchEl
        })
        this.$alert.close()
      }
    },
    fileHanle (e) {
      let files = e.srcElement.files[0]
      if (!files) return false
      this.$alert.load('上传中')

      lrz(files, { quality: 0.9 }).then(rst => {
        this.setPoster(rst.base64)
      })
    },
    cropFn () {
      let _canvas = document.createElement('canvas')
      let ctx = _canvas.getContext('2d')
      let num = 4
      let sprite = this.mySprite
      _canvas.width = sprite.boxWidth * num
      _canvas.height = sprite.boxHeight * num
      ctx.clearRect(0, 0, _canvas.width, _canvas.height)
      ctx.fillStyle = '#fb8aa8'
      ctx.fillRect(0, 0, _canvas.width, _canvas.height)
      ctx.save()
      ctx.translate((sprite.x + (sprite.width / 2)) * num, (sprite.y + (sprite.height / 2)) * num)
      ctx.scale(sprite.scale * num, sprite.scale * num)
      ctx.rotate(sprite.rotate * Math.PI / 180)
      ctx.drawImage(sprite.el, -(sprite.width / 2), -(sprite.height / 2))
      ctx.restore()
      let base64 = _canvas.toDataURL(`image/png`)
      return base64
    },
    printFn () {
      this.$alert.load('生成中')
      let img1 = this.cropFn()
      let img2 = this.posterType.url
      let imgArr = this.getImgEl([img1, img2])
      Promise.all(imgArr).then(res => {
        let wp = this.printPoster(res)
        this.$store.setState('winPoster', wp)
        this.$nextTick(() => {
          this.$alert.close()
          this.slideHandle(2)
        })
      }).catch(() => {
        this.$alert.close()
        this.$alert.warn('生成失败，请重试')
      })
    },
    printPoster (arr = []) {
      let _canvas = document.createElement('canvas')
      let _ctx = _canvas.getContext('2d')
      let num = 2
      _canvas.width = 750 * num
      _canvas.height = 1204 * num
      _ctx.clearRect(0, 0, _canvas.width, _canvas.height)
      for (let i = 0; i < arr.length; i++) {
        _ctx.drawImage(arr[i], 0, 0, _canvas.width, _canvas.height)
      }
      let winPoster = _canvas.toDataURL(`image/png`)
      return winPoster
    },
    getImgEl (arr) {
      return arr.map(url => {
        return new Promise((resolve, reject) => {
          let img = new Image()
          img.onload = e => {
            resolve(e.target)
          }
          img.onerror = err => {
            reject(err)
          }
          img.src = url
        })
      })
    },
    saveMissImgFn (data) {
      this.$http.saveMissImg({
        localData: data
      })
    }
  },
  created () {

  },
  mounted () {

  },
  beforeDestroy () {

  }
}
</script>

<style scoped>
.tab-box {
  padding: 3vh 0;
}
.poster-container {
  position: relative;
  width: 5rem;
  height: 8.03rem;
  box-sizing: content-box;
  border: .06rem solid #fff;
  background-color: #fb8aa8;
}
.poster-content,
.poster-type,
.poster-touch {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.poster-swiper {
  width: 68%;
}
.poster-swiper .poster-swiper-item {
  position: relative;
  display: block;
  width: 1.3rem;
  height: 1.3rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}
.poster-swiper .poster-swiper-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: .06rem solid #fff;
  opacity: 0;
  transform: scale(1.1);
  transition: opacity .4s ease-in-out, transform .4s ease-in-out;
}
.poster-swiper .poster-swiper-item-1 {
  background-image: url('../../assets/images/29.png');
}
.poster-swiper .poster-swiper-item-2 {
  background-image: url('../../assets/images/30.png');
}
.poster-swiper .poster-swiper-item-3 {
  background-image: url('../../assets/images/31.png');
}
.poster-swiper .poster-swiper-item.active::after {
  opacity: 1;
  transform: none;
}
.btn-box {
  width: 86%;
}
.up-btn-box {
  position: relative;
}
.up-btn-box #file {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  opacity: 0;
}
</style>
